import React, { useEffect, useState } from "react";
import Heading from '../../atoms/heading/Heading'
import styles from "./Legend.module.scss";
import classNames from 'classnames'

const Legend = (props) => {
  const { info, rounded = false } = props;

  const [legendItems, setLegendItems] = useState();

  const legendBoxStyle = classNames(styles.legendBox, { [styles.round]: rounded })

  useEffect(() => {
    if (info) {
      const colours = info.colours;
      const labels = info.labels;
      let build;

      if (colours.length === labels.length) {
        build = colours.map((colour, i) => {
          return (
            <div className={styles.legendItem} key={i}>
              <div
                className={legendBoxStyle}
                style={{ background: colour }}
              ></div>
              <div className={styles.legendText}>{labels[i]}</div>
            </div>
          );
        });
      } else {
        build = 'No legend data available'
      }
      setLegendItems(build);
    }
    // eslint-disable-next-line
  }, [info]);

  return (
    <div className={styles.container}>
      <Heading size={4} type={4} noMargin={true}>Legend</Heading>
      <Heading size={6} type={6}>{info.info}</Heading>
      {legendItems}
    </div>
  );
};

export default Legend;
